<template>
	<BaseCenteredPage hideLogoutButton class="bg-white">
		<template #nav-left>
			<!-- empty slot to hide logo -->
		</template>
		<main class="w-full h-full flex flex-col justify-center items-center gap-8 text-gray-500 text-lg">
			<BaseIcon name="mono/load" class="w-24 h-24" />
			<span>Opening...</span>
		</main>
	</BaseCenteredPage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'
import analytics from 'shared/utils/analytics'
import isExtensionInstalled from 'shared/mixins/isExtensionInstalled'
import {useUserCategory} from 'shared/composables/useUserCategory'

export default {
	name: 'AuthPostLogin',
	mixins: [isExtensionInstalled],
	setup() {
		useTitle('Logging in...')
		const {userCategory} = useUserCategory()
		return {userCategory}
	},
	async created() {
		// start a timer
		const startTime = Date.now()
		analytics.page('BugCaptureLoadingScreenAccessed', {user_category: this.userCategory})
		//This is implemented so this event can be tracked as an event and get populated in appcues event drop down refer: https://docs.appcues.com/dev-installing-appcues/installation-overview-for-developers?from_search=162506555
		analytics.track('BugCaptureLoadingScreenAccessed', {
			user_category: this.userCategory,
		})

		// BrowserStack users need to be redirected to different views depending on multiple factors:
		// - To the waitlist (if not qualifying for access)
		// - The Chrome Webstore (if not having the extension installed)
		// - Or the dashboard.

		const redirectAfterLogin = localStorage?.redirectAfterLogin || '/'
		delete localStorage?.redirectAfterLogin

		const navigationEventName = 'NavigatedFromBugCaptureLoadingScreen'

		// 1. only valid if user is a BrowserStack user
		if (!this.$store.user.browserstackUserId) {
			analytics.track(navigationEventName, {
				load_time: this.calculateTimeTakenMs(startTime),
				user_category: 'BEB users',
				status: 'success',
			})
			await this.$routerHelpers.push(redirectAfterLogin)
			return
		}

		analytics.track(navigationEventName, {
			load_time: this.calculateTimeTakenMs(startTime),
			user_category: this.userCategory,
			status: 'success',
		})

		if (this.$store.user.browserstackTosAccepted) {
			await this.$routerHelpers.push(redirectAfterLogin)
			return
		}

		// the complete-signup routes use this sessionStorage key to redirect the user to the right place after signup
		if (sessionStorage) {
			sessionStorage.redirectUrlAfterCompletingSignUp = redirectAfterLogin
		}
		await this.$routerHelpers.push('/complete-signup/get-started')
	},
	methods: {
		calculateTimeTakenMs(startTime) {
			const endTime = Date.now()
			const timeTaken = endTime - startTime
			return timeTaken
		},
	},
}
</script>
